// 当风廓线雷达图表准备完毕时的事件
export const WIND_PROFILE_CHART_READY = 'wind-profile-chart-ready'

// 当风廓线雷达图表准备销毁时的事件
export const WIND_PROFILE_CHART_DESTROY = 'wind-profile-chart-destroy'

// 当数据选中时的事件
export const WIND_PROFILE_CHART_DATA_SELECTED = 'wind-profile-chart-data-selected'

// 当数据取消选中的事件
export const WIND_PROFILE_CHART_DATA_CANCEL_SELECT = 'wind-profile-chart-data-cancel-select'

// 移动图表事件
export const WIND_PROFILE_CHART_MOVED = 'wind-profile-chart-moved'



// WEBPACK FOOTER //
// ./src/components/Data/Charts/WindProfileChart/EventKeys.js